const windowUtils = {
  // Accessor method for `window` for test stubbing purposes.
  getWindow() {
    return window;
  },
};

module.exports = windowUtils;
